import React, { useState, useEffect } from 'react';

import { ContentBox } from '../ContentBox';
import moment from 'moment';
import { setUserInfo, getUserInfoCompanyId, getval2Token } from '../../../Login/Auth';
import { PerformanceSearch } from './PerformanceSearch';
import { SingleLink, Space } from '../../Res/BaseButton';
import { Pagination } from '../../Res/Pagination';
import { RP_STATUS_COMPANY, RP_STATUS_DEPARTMENT, ReqRecruitmentPerformanceCount, RP_STATUS_CASEOWNER, KEY_STATUS_COMPANY, KEY_STATUS_DEPARTMENT, KEY_STATUS_CASEOWNER } from '../../../../item/ItemRecruitmentPerformanceContractorRelated';
import { api_getRecruitmentPerformanceCount } from '../../../../api/apiRecruitmentPerformanceContractorRelated';

export function RecruitmentPerformanceContractor({ id, status }) {
    const [tokenId, setTokenId] = useState("")
    const [tokenObj, setTokenObj] = useState(null)

    const [caseOwner, setCaseOwner] = useState("")
    const [caseOwnerName, setCaseOwnerName] = useState("")
    const [companyId, setCompanyId] = useState("")
    const [companyName, setCompanyName] = useState("")
    const [departmentId, setDepartmentId] = useState()
    const [departmentName, setDepartmentName] = useState()

    const [reserveCount, setReserveCount] = useState(0)
    const [onBoardCount, setOnBoardCount] = useState(0)
    const [cancelCount, setCancelCount] = useState(0)
    const [resignCount, setResignCount] = useState(0)

    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")

    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)
    const [items, setItems] = useState([])

    useEffect(() => {
        // console.log(id)
        if (id !== undefined && id !== tokenId) {
            var obj = getval2Token(status === RP_STATUS_COMPANY ? KEY_STATUS_COMPANY
                : status === RP_STATUS_DEPARTMENT ? KEY_STATUS_DEPARTMENT
                    : KEY_STATUS_CASEOWNER, id)
            // console.log(status)
            // console.log(obj)
            setTokenObj(obj)
            console.log(obj)
            switch (status) {
                case RP_STATUS_COMPANY:

                    break;
                case RP_STATUS_DEPARTMENT:
                    break;
                default:
                    setCaseOwner(obj.caseOwner)
                    setCaseOwnerName(obj.caseOwnerName)
                    break;
            }
            setCompanyId(obj.companyId)
            setCompanyName(obj.companyName)
            setDepartmentId(obj.departmentId)
            setDepartmentName(obj.departmentName)
            setTokenId(id)
        }
    }, [id])

    // useEffect(()=>{
    //     if(companyId !== "")
    //         getCount()
    // },[companyId])

    // useEffect(() => {
    //     // console.log(userInfo === mUserInfo)
    //     if (mUserInfo === undefined) {
    //         // console.log(userInfo)
    //         setCaseOwner(userInfo.accountId)
    //         setCaseOwnerName(userInfo.nickName)
    //         setCompanyId(userInfo.companyId)
    //         setCompanyName(userInfo.companyName)
    //         setDepartmentId(userInfo.departmentId)
    //         setUserInfo(userInfo)
    //     }
    //     // console.log(userInfo)
    // }, [userInfo])

    function getCount() {
        var start = (page - 1) * limit;
        var mReqRecruitmentPerformanceCount = new ReqRecruitmentPerformanceCount({
            status,
            companyId,
            departmentId,
            caseOwner,
            startDate: moment(startDate).format('YYYY-MM-DD'),
            endDate: moment(endDate).format('YYYY-MM-DD'),
            limit,
            start
        })
        if(departmentId === undefined)
        return
        // console.log(mReqRecruitmentPerformanceCount)
        api_getRecruitmentPerformanceCount({
            mReqRecruitmentPerformanceCount,
            success: (obj) => {
                // console.log(obj.list)
                var reserveCount = 0
                var onBoardCount = 0
                var cancelCount = 0
                var resignCount = 0
                obj.list.map((item) => {
                    reserveCount += item.reserveCount
                    onBoardCount += item.onBoardCount
                    cancelCount += item.cancelCount
                    resignCount += item.resignCount
                })
                setReserveCount(reserveCount)
                setOnBoardCount(onBoardCount)
                setCancelCount(cancelCount)
                setResignCount(resignCount)
                setItems(obj.list)
            },
            failure: (err) => {
                console.log(err)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    var superTitle = status === RP_STATUS_COMPANY ? companyName : status === RP_STATUS_DEPARTMENT ? departmentName : caseOwnerName
    var title = "招募績效"
    var content =
        <>
            {tokenId === "" ? <></> :
                <PerformanceSearch
                    action={getCount}
                    ssd={setStartDate}
                    sed={setEndDate}
                    reserveCount={reserveCount}
                    onBoardCount={onBoardCount}
                    cancelCount={cancelCount}
                    resignCount={resignCount}
                />
            }
            <Space />
            {status === RP_STATUS_CASEOWNER ? <></> :
                <RecruitmentPerformanceListBox list={items} count={count} page={page} sp={setPage} status={status} obj={tokenObj} />
            }
        </>
    return (
        <ContentBox superTitle={superTitle} title={title} content={content} hasDrawer={false} />
    )
}


function RecruitmentPerformanceListBox({ list, srl, count, page, sp, status, obj }) {
    const [customerContractList, setCustomerContractList] = useState([])
    const [itemList, setItemList] = useState([])
    const [mPage, setPage] = useState(1)
    const [limit] = useState(10)
    const [mCount, setCount] = useState(0)

    const [iStart, setStart] = useState(0)
    const [iEnd, setEnd] = useState(0)

    useEffect(() => {
        // console.log(list)
        if (list !== undefined && customerContractList !== list) {
            setCustomerContractList(list)
            setStart((page - 1) * limit + 1)
            setEnd((page - 1) * limit + list.length)
            setItemList(setTableList(list))
            setPage(page)
        }

        if (count !== mCount) {
            setCount(count)
        }
    }, [list, count])

    function setTableList(list) {
        var itemList = []
        for (var i = 0; i < limit; i++) {
            if (list[i] !== undefined) {
                itemList.push(<RecruitmentPerformanceContractorBox key={status === RP_STATUS_COMPANY ? list[i].departmentId : list[i].caseOwner} item={list[i]} status={status} obj={obj} />)
            } else {
                itemList.push(<RecruitmentPerformanceContractorBox key={"resumeId" + i} />)
            }
        }
        return itemList
    }

    function sPage(p) {
        console.log("pagechange" + p)
        if (p !== page) {
            sp({ page: p })
            setPage(p)
        }
    }

    if (itemList.length === 0) {
        return (<></>)
    } else {
        //console.log(managerList)
        return (
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-2">姓名</th>
                                    <th className="text-center sorting col-sm-2">預定</th>
                                    <th className="text-center sorting col-sm-2">報到</th>
                                    <th className="text-center sorting col-sm-2">未報到</th>
                                    <th className="text-center sorting col-sm-2">離職</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    itemList.map((item) => (
                                        item
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} s={iStart} e={iEnd} />
                }
            </div>
        )
    }

}

function RecruitmentPerformanceContractorBox({ item, status, obj }) {
    const [mItem, setItem] = useState({})
    const [companyId, setCompanyId] = useState(getUserInfoCompanyId())
    const [companyName, setCompanyName] = useState("")
    const [departmentId, setDepartmentId] = useState("")
    const [departmentName, setDepartmentName] = useState("")
    const [caseOwner, setCaseOwner] = useState("")
    const [caseOwnerName, setCaseOwnerName] = useState("")

    const [reserveCount, setReserveCount] = useState("")
    const [onBoardCount, setOnBoardCount] = useState("")
    const [cancelCount, setCancelCount] = useState("")
    const [resignCount, setResignCount] = useState("")

    useEffect(() => {
        if (item !== undefined && item !== mItem) {
            // console.log(item)
            // console.log(obj)
            setItem(item)
            setCompanyId(item.companyId || obj.companyId)
            setCompanyName(item.companyName || obj.companyName)
            setDepartmentId(item.departmentId || obj.departmentId)
            setDepartmentName(item.departmentName || obj.departmentName)
            setReserveCount(item.reserveCount)
            setOnBoardCount(item.onBoardCount)
            setCancelCount(item.cancelCount)
            setResignCount(item.resignCount)
            setCaseOwner(item.caseOwner)
            setCaseOwnerName(item.caseOwnerName)
        }

    }, [item])

    return (
        <tr role="row">
            <td className="text-center">
                <SingleLink link={
                    status === RP_STATUS_COMPANY ? "RecruitmentPerformance_SpecialistList"
                        : status === RP_STATUS_DEPARTMENT ? "RecruitmentPerformance_ContractorRelatedList"
                            : ""}
                    name={status === RP_STATUS_COMPANY ? departmentName
                        : status === RP_STATUS_DEPARTMENT ? caseOwnerName
                            : ""}
                    Key={status === RP_STATUS_COMPANY ? KEY_STATUS_DEPARTMENT
                        : status === RP_STATUS_DEPARTMENT ? KEY_STATUS_CASEOWNER
                            : ""}
                    val={{
                        companyId: companyId,
                        companyName: companyName,
                        departmentId: departmentId,
                        departmentName: departmentName,
                        caseOwner,
                        caseOwnerName
                    }} >
                </SingleLink>
            </td>
            {/* <td className="text-center"><a href="#A" onClick={e => toSOP()}>{caseContractorName}</a></td> */}
            {/* <td className="text-center"><a href="#A" onClick={e => toIsOrNotOnboardSOP()}>{age}</a></td>
            <td className="text-center">{sex}</td> */}
            <td className="text-center">{reserveCount}</td>
            <td className="text-center">{onBoardCount}&nbsp;</td>
            <td className="text-center">{cancelCount}</td>
            <td className="text-center">{resignCount}</td>
        </tr>
    )
}
